module.exports = __webpack_public_path__ + "img/tofubowlfront.f4774397.png";